import { BackArrow, BlueVerification, GreenVerification } from "assets/icons";

function VerifyCard({
  title,
  description,
  status,
  variant = "id",
  uniqueCode,
  onClick,
  showBackArrow = false,
}) {
  return (
    <div
      onClick={onClick}
      className={`flex items-center card-container pointer ${status === "PENDING" && "pending-card"}`}
    >
      <div className="w-full flex justify-between gap-3 items-start">
        <div className="flex flex-col gap-1">
          <div className="flex items-center gap-2">
            <span className="font-title-normal leading-5">{title}</span>
            <span className="icon">
              {variant === "id" ? <BlueVerification /> : <GreenVerification />}
            </span>
          </div>
          <p className="font-body-md2 leading-5">{description}</p>
          {uniqueCode && (
            <div className="flex items-center gap-2 mt-3">
              <p className="font-body-normal leading-4 code-text">
                Unique verification code
              </p>
              <span className="font-body-md leading-3">{uniqueCode}</span>
            </div>
          )}
        </div>
        {status && <span className="status-text">{status}</span>}
      </div>
      {showBackArrow && (
        <span className="arrow-icon pointer">
          <BackArrow />
        </span>
      )}
    </div>
  );
}

export default VerifyCard;
